/* lystia-home-types.js - Головна · «Обери за типом» (T-E6-03; prototype home.js types()).
   <lystia-home-types>: стрілки (крок = 2 ширини плитки + 12, scrollBy smooth) і прогрес-бар із thumb.
   Розмітка: [data-types-track], [data-types-thumb], [data-types-prev], [data-types-next]. */
(function () {
  'use strict';
  if (customElements.get('lystia-home-types')) return;

  class LystiaHomeTypes extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-types-track]');
      this.thumb = this.querySelector('[data-types-thumb]');
      this.prev = this.querySelector('[data-types-prev]');
      this.next = this.querySelector('[data-types-next]');
      if (!this.track || !this.thumb) return;
      this.update = this.update.bind(this);
      this.onPrev = () => this.track.scrollBy({ left: -this.step(), behavior: 'smooth' });
      this.onNext = () => this.track.scrollBy({ left: this.step(), behavior: 'smooth' });
      this.track.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update);
      if (this.prev) this.prev.addEventListener('click', this.onPrev);
      if (this.next) this.next.addEventListener('click', this.onNext);
      this.update();
      this.t1 = setTimeout(this.update, 60);
      this.t2 = setTimeout(this.update, 600);
    }

    disconnectedCallback() {
      clearTimeout(this.t1);
      clearTimeout(this.t2);
      window.removeEventListener('resize', this.update);
      if (this.track) this.track.removeEventListener('scroll', this.update);
      if (this.prev) this.prev.removeEventListener('click', this.onPrev);
      if (this.next) this.next.removeEventListener('click', this.onNext);
    }

    step() {
      const first = this.track.firstElementChild;
      return (first ? first.offsetWidth + 12 : 300) * 2;
    }

    update() {
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth;
      const vis = t.clientWidth / (t.scrollWidth || 1);
      this.thumb.style.width = Math.max(10, Math.min(100, vis * 100)) + '%';
      this.thumb.style.transform = 'translateX(' + (max > 0 ? (t.scrollLeft / max) * (100 / vis - 100) : 0) + '%)';
      if (this.prev) this.prev.disabled = t.scrollLeft <= 2;
      if (this.next) this.next.disabled = t.scrollLeft >= max - 2;
    }
  }

  customElements.define('lystia-home-types', LystiaHomeTypes);
})();
